class BackToTop extends HTMLElement {
  constructor() {
    super();

    if (!this.closest("body")) return;
    this.anchor = this.closest("body").querySelector(".main-product");
    this.button = this.querySelector("button");
  }

  connectedCallback() {
    this.scrollObserver();

    this.button.addEventListener("click", () => {
      this.scrollToTop();

      // Shift focus to first focusable element in main content
      document.querySelector("#MainContent a, #MainContent button")?.focus();
    });
  }

  scrollObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.isIntersecting ? this.hideButton() : this.showButton();
      });
    });

    observer.observe(this.anchor);
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  hideButton() {
    this.button.classList.add("back-to-top__button--hidden");
  }

  showButton() {
    this.button.classList.remove("back-to-top__button--hidden");
  }
}

if (!customElements.get("back-to-top")) {
  customElements.define("back-to-top", BackToTop);
}
